import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useViewportDevice } from '@zep/react';
import { Button } from '@zep/ui';
import { joinUtmQueryParams } from '../../../../../utils';
import S from './PricingContact.module.scss';
export const PricingContact = () => {
  const {
    t
  } = useTranslation(['subscription'], {
    useSuspense: true
  });
  const {
    isTablet
  } = useViewportDevice();
  const router = useRouter();
  return <section className={S.section} data-sentry-component="PricingContact" data-sentry-source-file="PricingContact.tsx">
      <div className={S.inner}>
        <div className={S.box}>
          <div className={S.title}>
            {t('subscription:pricing.contact.title')}
          </div>
          <Button as="a" href={joinUtmQueryParams(t('subscription:pricing.contact.buttonLink'), router)} target="_blank" className="min-w-[150px]" size={isTablet ? 'sm' : 'md'} onClick={() => logger.track('home_pricing_contact')} data-sentry-element="Button" data-sentry-source-file="PricingContact.tsx">
            {t('subscription:pricing.contact.buttonText')}
          </Button>
        </div>
      </div>
    </section>;
};